import * as React from 'react';
import { CurrencyRow } from './CurrencyRow/CurrencyRow';
import { ClaimRow } from './ClaimRow/ClaimRow';
import FundsChart from '@funds/components/FundsChart/FundsChart';
import Big from 'big.js';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import { Spinner } from '../Spinner/Spinner';
import { CelsiusClaimBalance, CelsiusClaimData } from '../../CelsiusClaimPage';

import * as style from './CelsiusClaimStyles.module.scss'
const big = Big();

type Props = {
  balances: CelsiusClaimBalance[];
  claimData: CelsiusClaimData;
};

export const CelsiusClaim = ({ balances, claimData }: Props) => {
  const estimatedFunds = balances.reduce(
    (prev: number, curr: CelsiusClaimBalance) => {
      return Number(big(prev).add(curr.total_usd || 0));
    },
    0
  );

  if (balances.length === 0) {
    return <Spinner />;
  }
  return (
    <div className={style.celsiusClaimPage}>
      <div className={style.celsiusClaimPageContent}>
        <div className={style.balancesTableWrapper}>
          <div className={style.balancesHeader}>
            <h1 className={style.header}>Celsius Claim</h1>
            <div className={style.balancesHeaderColumns}>
              <div></div>
              <div>Total claim</div>
            </div>
          </div>
          <div className={style.balancesTable}>
            {balances.map((balance, index) => (
              <CurrencyRow
                key={index}
                data={{
                  currency_name: balance.currency_name?.name,
                  currency: balance.currency,
                  balance_type: balance.balance_type,
                  balance: parseFloat(balance.balance),
                }}
                index={index}
              />
            ))}
          </div>
        </div>
        <FundsChart
          manageAccountLink={false}
          headline="Estimated total Claim"
          data={balances.map((balance) => ({
            total_usd: parseFloat(balance.total_usd),
            currency_name: balance.currency_name?.name,
          }))}
          sum={estimatedFunds}
        />
      </div>
      <div className={style.celsiusClaimPageContent}>
        <div className={style.balancesTableWrapper}>
          <div className={style.balancesHeader}>
            <h1 className={style.header}>Total claim amounts</h1>
          </div>
          <div className={style.balancesTable}>
            {Object.entries(claimData).map(([loss_name, amount], index) => (
              <ClaimRow
               index={index}
               loss_name={loss_name}
               amount={amount}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
